import { strings as stringManager } from '../../Strings';
export const moduleName = 'rangeDistributionCard';
stringManager.load(moduleName, {
    above: 'Above',
    below: 'Below',
    bottom: 'Bottom',
    cardTitle: 'Range Distribution',
    descriptionInRange: '{0} and {1} of the organization are in the',
    descriptionInRangeSingular: '{0} is in the',
    descriptionOutRange: '{0} and {1} of the organization are',
    descriptionOutRangeSingular: '{0} is',
    descriptionPositionInRange: 'of the range',
    descriptionPositionOutRange: 'the range',
    middle: 'Middle',
    thisEmployee: 'This employee',
    top: 'Top'
});
const moduleStrings = stringManager[moduleName];
export { moduleStrings as strings };
export default moduleStrings;
